"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimestampSchema = void 0;
exports.TimestampSchema = {
    "$id": "https://www.redbull.com/schemas/attributes/timestamp.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "Timestamp",
    "description": "timestamp",
    "type": "object",
    "additionalProperties": false,
    "properties": {
        "type": {
            "type": "string",
            "enum": [
                "attributes:timestamp"
            ]
        },
        "time": {
            "type": "string",
            "pattern": "^[0-9]{2}:[0-9]{2}:[0-9]{2}$"
        }
    },
    "required": [
        "type",
        "time"
    ]
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidGltZXN0YW1wLnNjaGVtYS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9tb2R1bGVzL2F0dHJpYnV0ZXMvdGltZXN0YW1wLnNjaGVtYS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBYSxRQUFBLGVBQWUsR0FBRztJQUM3QixLQUFLLEVBQUUsa0VBQWtFO0lBQ3pFLFNBQVMsRUFBRSw4Q0FBOEM7SUFDekQsT0FBTyxFQUFFLFdBQVc7SUFDcEIsYUFBYSxFQUFFLFdBQVc7SUFDMUIsTUFBTSxFQUFFLFFBQVE7SUFDaEIsc0JBQXNCLEVBQUUsS0FBSztJQUM3QixZQUFZLEVBQUU7UUFDWixNQUFNLEVBQUU7WUFDTixNQUFNLEVBQUUsUUFBUTtZQUNoQixNQUFNLEVBQUU7Z0JBQ04sc0JBQXNCO2FBQ3ZCO1NBQ0Y7UUFDRCxNQUFNLEVBQUU7WUFDTixNQUFNLEVBQUUsUUFBUTtZQUNoQixTQUFTLEVBQUUsOEJBQThCO1NBQzFDO0tBQ0Y7SUFDRCxVQUFVLEVBQUU7UUFDVixNQUFNO1FBQ04sTUFBTTtLQUNQO0NBQ0YsQ0FBQSJ9